import { ReactNode } from "react";

import { WindowRenderModeContext } from "./windowRenderModeContext";

/**
 * When rendered inside this provider, the {@link Window} component skips all
 * chrome (header, drag handle, resize, shadow) and renders only its children.
 * Used by the mobile panel/drawer routing so that SDK-provided window
 * components don't double-wrap inside the panel's own chrome.
 */
export function WindowContentOnlyProvider({ children }: { children: ReactNode }) {
    return <WindowRenderModeContext.Provider value="contentOnly">{children}</WindowRenderModeContext.Provider>;
}

/**
 * Like `WindowContentOnlyProvider` but for the desktop dock: renders the title
 * row plus a flex-column scrollable body that routes children through
 * `WindowOverlays`. Kept separate from `contentOnly` so the mobile panel/drawer
 * path is not affected.
 */
export function WindowDockedProvider({ children }: { children: ReactNode }) {
    return <WindowRenderModeContext.Provider value="docked">{children}</WindowRenderModeContext.Provider>;
}
